import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import _defineProperty from "E:/workSpacke/screening-sys/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import { getImportRecordNotSee } from "@/api/screening";
export default {
  name: "Notice",
  computed: _objectSpread({}, mapGetters(["roles"])),
  data: function data() {
    return {
      noticeTips: false,
      noticeData: [],
      plan_type: undefined,
      query: {}
    };
  },
  sockets: {
    connect: function connect() {
      console.log("socket connected from Page");
    },
    disconnect: function disconnect() {
      console.log("socket disconnect");
    },
    newImpArchivesResult: function newImpArchivesResult(data) {
      //此方法后台已弃用
      // 监听message事件，方法是后台定义和提供的
      this.noticeTips = true;
      this.noticeData = data;
    }
  },
  mounted: function mounted() {
    // if (process.env.VUE_APP_MODE != 'xm' && process.env.VUE_APP_MODE != 'hb') {
    //   this.$socket.emit("connect") //在这里触发connect事件
    // }
  },
  methods: {
    //关闭预警提示
    goNoticeTips: function goNoticeTips() {
      this.noticeTips = false;
      if (this.roles[0] == "screen") {
        if (this.plan_type == 1 || this.plan_type == 4 || this.plan_type == 5) {
          this.$router.push({
            path: "/screen/manage/studentmanage",
            query: this.query
          });
        } else if (this.plan_type == 2 || this.plan_type == 3) {
          this.$router.push({
            path: "/screen/manage/personmanage",
            query: this.query
          });
        } else {
          this.$router.push({
            path: "/screen/functionally/screenfilemanage"
          });
        }
        this.resetSetItem("archive_history", "1");
      }
    },
    // 筛查机构获取导入成功提示
    getdata: function getdata() {
      var _this = this;
      getImportRecordNotSee({}).then(function (res) {
        if (res.error == -1) {
          if (res.data.length > 0) {
            _this.plan_type = res.data[0].plan_type;
            _this.noticeTips = true;
            _this.noticeData = res.data;
            _this.query = {
              planType: res.data[0].plan_type,
              planId: res.data[0].plan_id,
              schoolName: res.data[0].school,
              schoolId: res.data[0].school_id
            };
          }
        }
      });
    }
  },
  created: function created() {
    if (this.$route.path != "/screen/functionally/screensendnotify" && this.roles[0] == "screen") {
      this.getdata();
    }
  }
};